import React, { forwardRef } from 'react';
import classnames from 'classnames';

import './PanelBlock.scss';

export default forwardRef(function PanelBlock(props, ref) {
  // eslint-disable-next-line react/prop-types
  const { children, className } = props;
  return (
    <div className={classnames('panel-block', className)} ref={ref}>
      {children}
    </div>
  );
});
